import { Property } from '../../../types';
import { HealthIssue } from '../../../types/inventoryHealth';

export function isApartmentOrStudio(tipo?: string | null): boolean {
  if (!tipo) return false;
  const norm = tipo.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return (
    norm.includes('apartamento') ||
    norm.includes('apartaestudio') ||
    norm.includes('apto') ||
    norm.includes('departamento')
  );
}

export function requiresAdminFee(tipo?: string | null): boolean {
  if (!tipo) return false;
  const norm = tipo.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return (
    norm.includes('apartamento') ||
    norm.includes('apartaestudio') ||
    norm.includes('apto') ||
    norm.includes('departamento') ||
    norm.includes('deposito') ||
    norm.includes('local') ||
    norm.includes('oficina')
  );
}

export function checkAdminFeeRule(property: Property): HealthIssue | null {
  if (!requiresAdminFee(property.tipoinmueble)) {
    return null;
  }

  const rawVal = property.valor_administracion;
  const adminFee = typeof rawVal === 'number' ? rawVal : Number(String(rawVal || '0').replace(/[^0-9]/g, ''));

  if (!adminFee || adminFee < 100000) {
    const formatted = adminFee > 0 ? `$${adminFee.toLocaleString('es-CO')}` : '$0 o no asignado';
    return {
      ruleId: 'admin_fee',
      ruleName: 'Administración Inválida (< $100.000)',
      severity: 'critical',
      message: `${property.tipoinmueble || 'Inmueble'} con administración de ${formatted}. Debe ser ≥ $100.000.`,
      field: 'valor_administracion',
      currentValue: adminFee,
      suggestedFix: 'Digitar el valor real de administración mensual en pesos colombianos.',
    };
  }

  return null;
}
